import React, { useMemo } from 'react';
import _get from 'lodash/get';
import _keyBy from 'lodash/keyBy';
import * as FormValues from 'types/FormValue';
import * as Types from 'pages/Features/typings';
import { Field } from '@sift/types';
import * as PageTypes from 'pages/Pages/typings';
import isFieldValidConfigOption from 'helpers/isFieldValidConfigOption';

// Components
import LayoutSettingCard from 'molecules/LayoutSettingCard';

interface Props {
  onChange: (field: any, value: FormValues.FormValue) => void;
  userStatus: number;
  fields: Field[];
  values: Types.FeatureValues | PageTypes.EntitySettingsFormValues;
  typeKey?: string;
  className?: string;
}

export const FILTER_SUBTITLE_COPY =
  'Define which attributes may be filtered by on your Directory and Explore pages.';

export const FILTERABLE_FIELD_TYPES = ['text', 'textSelect', 'multiSelect', 'boolean', 'number'];

export const fieldIsFilterable = (field: Field) => {
  const fieldTypeIsFilterable = (field: Field) =>
    FILTERABLE_FIELD_TYPES.includes(field.type) ||
    (field.type === 'collection' && _get(field, 'item.type') === 'text');

  return fieldTypeIsFilterable(field) && isFieldValidConfigOption(field);
};

function FilterLayout({
  userStatus,
  fields,
  onChange,
  values,
  typeKey = 'user',
  className,
}: Props) {
  const keyedFields = useMemo(() => _keyBy(fields, 'objectKey'), [fields]);

  return (
    <LayoutSettingCard
      cardTitle="Filters"
      dialogTitle="Configure Filters"
      filter={fieldIsFilterable}
      layoutKey="filters"
      subtitle={FILTER_SUBTITLE_COPY}
      userStatus={userStatus}
      fields={keyedFields}
      onChange={onChange}
      values={values}
      typeKey={typeKey}
      className={className}
    />
  );
}

export default FilterLayout;
